module.exports = __webpack_public_path__ + "static/media/cow.16705a95.svg";